import React from 'react';
import { Traveler } from '@marageti/z4-sdk/lib/people';
import { useApiClient, useFetchImmutable, useQueryParams } from '@marageti/z4-lib';
import { TimeZoneMap } from '@marageti/z4-sdk/lib/standards';
import { Navigate, useNavigate } from 'react-router-dom';
import { FieldValues } from 'react-hook-form';
import { useAuthStore } from '../../../../store';
import { buildLoginPath } from '../../helpers';
import ConfirmPhoneView from './confirm-phone-view';

const DEFAULT_VALUES = {
  phone: {
    prefix: '',
    number: '',
  },
  timeZone: {
    name: '',
    rawOffsetInMinutes: 0,
  },
};

const ConfirmPhone = (): React.ReactElement => {
  const {
    setIsAuthenticated,
    setAuthenticatedTraveler,
    loggedInTraveler,
  } = useAuthStore();
  const apiClient = useApiClient();
  const navigate = useNavigate();
  const { tripRequestId } = useQueryParams();
  const destination = tripRequestId ? `/trip-requests/${tripRequestId}` : '/';

  const timezones = useFetchImmutable<TimeZoneMap>(apiClient.standardsClient.getTimeZones, [], true);
  const timezonesMap = timezones.data ? new Map(Object.entries(timezones.data)) : new Map();
  const suggestedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone.replace(/_/g, ' ');
  const suggestedTimezoneOption = timezonesMap.has(suggestedTimezone) ? {
    name: suggestedTimezone,
    rawOffsetInMinutes: timezonesMap.get(suggestedTimezone),
  }
    : DEFAULT_VALUES.timeZone;

  if (!loggedInTraveler) {
    return (
      <Navigate
        to={buildLoginPath('user_identification', new URLSearchParams(window.location.search))}
        replace
      />
    );
  }

  const handleSubmit = (data: FieldValues) => {
    const { phone, timeZone } = data;
    const request = {
      ...loggedInTraveler,
      ...phone.number && { phone: data.phone },
      ...timeZone.name && { timeZone: data.timeZone },
    };
    return apiClient.peopleClient.putTraveler(loggedInTraveler.id, request)
      .then((res: Traveler) => {
        setAuthenticatedTraveler(res);
      })
      .catch(console.error)
      .finally(() => {
        setIsAuthenticated(true);
        navigate(destination);
      });
  };

  return (
    <ConfirmPhoneView
      defaultValues={{
        phone: loggedInTraveler.phone || DEFAULT_VALUES.phone,
        timeZone: loggedInTraveler.timeZone.name
          ? loggedInTraveler.timeZone
          : suggestedTimezoneOption,
      }}
      onSubmit={handleSubmit}
    />
  );
};

export default ConfirmPhone;
